import './styles.css'

import React from 'react'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const LOCATION_OPTIONS = [
  { key: 'inside', label: 'Inside', value: 'Inside' },
  { key: 'front', label: 'Out the Front', value: 'Out the Front' },
  { key: 'back', label: 'Out the Back', value: 'Out the Back' },
]

function KegCollectionLocationBtnGroup(props) {
  const { onClick, isDisabled, formValues } = props
  const { t: translate } = useTranslation()

  return (
    <div className="keg-collection-location-btn-group" role="group">
      {LOCATION_OPTIONS.map(o => {
        const selected = formValues.kegLocation === o.value
        return (
          <button
            key={o.key}
            type="button"
            className={`keg-collection-location-btn${selected ? ' is-selected' : ''}`}
            aria-pressed={selected}
            disabled={isDisabled}
            onClick={() => onClick(o.value)}
          >
            <Icon
              name="map marker alternate"
              className="keg-collection-location-btn__icon"
              aria-hidden="true"
            />
            <span className="keg-collection-location-btn__label">{translate(o.label)}</span>
          </button>
        )
      })}
    </div>
  )
}

export default React.memo(KegCollectionLocationBtnGroup)
